import { GRAND_PRIZE_COUNT, fmtDay, fmtDayOrdinal } from '../campaign';
import { GoldButton } from './Shared';
import { BellIcon } from './Icons';

/* Footer pinned to the bottom of the screen before launch and after the
   draw. Pre-launch: launch message plus the reminder toggle ("Notify Me" ↔
   "Reminder set for 18 Oct"). Ended: the draw is done, "See the winners"
   opens the results sheet. `launch` / `drawOn` are the campaign dates. */
export default function StickyBar({
  phase = 'pre', grandTotal = GRAND_PRIZE_COUNT, launch, drawOn, notify, onToggle, onWinners,
}) {
  if (phase === 'ended') {
    return (
      <div className="gq-sticky">
        <div className="gq-t gq-msg">The grand draw is done. {grandTotal} grand prizes went out on {drawOn ? fmtDay(drawOn) : '13 Nov'}.</div>
        <GoldButton onClick={onWinners}>See the winners</GoldButton>
      </div>
    );
  }
  const launchDay = launch ? fmtDay(launch) : '18 Oct';
  return (
    <div className="gq-sticky">
      <div className="gq-t gq-msg">Campaign starts on the {launch ? fmtDayOrdinal(launch) : '18th October'}.</div>
      <GoldButton className={notify ? 'gq-set' : ''} onClick={onToggle} aria-pressed={notify}>
        <span className="gq-bell"><BellIcon /></span>
        <span>{notify ? `Reminder set for ${launchDay}` : 'Notify Me'}</span>
      </GoldButton>
    </div>
  );
}
